module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-backForm', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.full_screenFlag),
      expression: "full_screenFlag",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "name": 'back-bonus-cycle',
      "align": true
    },
    on: {
      "save": _vm.saveSet,
      "cancel": _vm.backset
    }
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("奖金周期")]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("起始月份")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.startMonth),
      expression: "sub.startMonth"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.startMonth),
      callback: function($$v) {
        _vm.$set(_vm.sub, "startMonth", $$v)
      },
      expression: "sub.startMonth"
    }
  }, _vm._l((12), function(month) {
    return _c('el-option', {
      key: month,
      attrs: {
        "value": month,
        "label": (month + "月")
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("下一周期起始月份")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("周期间隔")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.type),
      expression: "sub.type"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sub.type),
      callback: function($$v) {
        _vm.$set(_vm.sub, "type", $$v)
      },
      expression: "sub.type"
    }
  }, _vm._l((_vm.cycle_interval), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "value": item.val,
        "label": item.text
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm._f("cycleTip")(_vm.sub.startMonth, _vm.sub.type)))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }, [_vm._v("奖金分配")]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("分配时长")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: (5),
      expression: "5"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.distribute_days),
      expression: "sub.distribute_days"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "number cycle_day"
    },
    model: {
      value: (_vm.sub.distribute_days),
      callback: function($$v) {
        _vm.$set(_vm.sub, "distribute_days", $$v)
      },
      expression: "sub.distribute_days"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("工作日")])], 2), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("奖金分配的持续时间")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }, [_vm._v("奖金结算")]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("结算时长")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: (5),
      expression: "5"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.settle_days),
      expression: "sub.settle_days"
    }],
    staticClass: "top-choose",
    attrs: {
      "rule": "number cycle_day"
    },
    model: {
      value: (_vm.sub.settle_days),
      callback: function($$v) {
        _vm.$set(_vm.sub, "settle_days", $$v)
      },
      expression: "sub.settle_days"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("工作日")])], 2), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("系统完成奖金结算的持续时间，默认在奖金分配结束后开启")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0432bb19!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/bonus-cycle.vue
// module id = 682
// module chunks = 1